import { fieldMixin, formErrorMixin } from "../../../mixins";
//import $ from 'jquery';
//import 'jquery-mask-plugin'

export default {
  mixins: [fieldMixin, formErrorMixin],

  props: {
    onlyNumber: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      placeholder: "",
      localValue: this.value
    };
  },

  computed: {
    inputClass() {
      return ["form-control"];
    }
  },

  render(h) {
    const t = this;

    let directives = [];

    /* Only Number Directive **/
    if (t.onlyNumber != false) {
      directives.push({ name: "only-number", value: true });
    }

    return h("input", {
      ref: "input",
      class: t.inputClass,
      domProps: { value: t.localValue },
      directives: directives,
      attrs: {
        name: t.name,
        type: t.type,
        disabled: t.disabled,
        required: t.required,
        list: t.list,
        readonly: t.readonly || t.plaintext,
        placeholder: t.placeholder
      },
      on: {
        //input: t.onInput,
        change: t.handleOnChange
      }
    });
  },

  mounted() {
    //if (this.mask != null) {
    //$(this.$el).mask(this.mask)
    //}
  },

  watch: {
    value(newVal, oldVal) {
      this.localValue = newVal;
    },

    localValue(newVal, oldVal) {
      this.clearError();
      this.$emit("input", this.localValue);
    }
  },

  methods: {
    handleOnChange(event) {
      this.$emit("input", event.target.value);
    }
  }
};
